module.exports = __webpack_public_path__ + "img/02.6bb5bb17.png";